const machine_txt = {
    type: "VA-L01-D1",
    name: "Direct Drive High Speed Lockstitch Sewing Machine With Automatic Thread Trimming",
    description: [
        "Core direct-drive transmission technology, empowering both high efficiency and energy saving, the motor adopts an integrated direct connection design with the main shaft, achieving zero intermediate loss in power transmission.",
        "Enhanced by intelligent electronic control system, featuring precise and user-friendly operation, no empty stitches or skipped stitches at the start of sewing, with flat and firm stitch beginnings. The electronic speed cont-csystem is paired with a pedal with adjustable sensitivity.",
        "Robust structural design with strong thick-fabric capacity and as apacdity and wide adaptability, widely applicable to multiple industries such as apparel, home textiles, luggage, footwear, and automotive interiors, meeting diverse production needs."
    ],
    //绝对路径
    machine_img:[
        "/assets/machine/1/machine_img/1.jpg",
        "/assets/machine/1/machine_img/2.jpg",
        "/assets/machine/1/machine_img/3.jpg",
        "/assets/machine/1/machine_img/4.jpg",
        "/assets/machine/1/machine_img/5.jpg",
        "/assets/machine/1/machine_img/6.jpg",
        "/assets/machine/1/machine_img/7.jpg",
        "/assets/machine/1/machine_img/8.jpg",
        "/assets/machine/1/machine_img/9.jpg",
        "/assets/machine/1/machine_img/10.jpg"
    ],
    machine_other_img:[
        "/assets/machine/1/machine_other/1.png",

    ]
}
export default {machine_txt}